/** **   request.js   ****/
// 导入axios
import axios from 'axios'
// import qs from 'qs'
// 使用element-ui Message做消息提醒
import { MessageBox, Loading } from 'element-ui'
// 错误消息判断
import cookie from '@utils/cookie'
// import { serverUrl } from "@utils";
import router from '../router'
import i18n from './i18n'
import { responseCode, responseMessage } from './apiResponse'

function translateServerMessage (message) {
  const msg = String(message || '').trim()
  const locale = i18n.locale || 'zh'
  const localeKey = locale.indexOf('en') === 0 ? 'en' : (locale.indexOf('ja') === 0 ? 'ja' : 'zh')
  const messageMap = {
    'The invitation code does not exist': {
      zh: '邀请码不存在，请检查后重新输入',
      en: 'The invitation code does not exist',
      ja: '招待コードが存在しません。入力内容をご確認ください'
    },
    'Invitation code does not exist': {
      zh: '邀请码不存在，请检查后重新输入',
      en: 'The invitation code does not exist',
      ja: '招待コードが存在しません。入力内容をご確認ください'
    },
    邀请码不存在: {
      zh: '邀请码不存在，请检查后重新输入',
      en: 'The invitation code does not exist',
      ja: '招待コードが存在しません。入力内容をご確認ください'
    },
    'The user center login password you entered is incorrect': {
      zh: '您输入的用户中心密码不正确',
      en: 'The User Center password you entered is incorrect',
      ja: '入力したユーザーセンターのパスワードが正しくありません'
    },
    'The login password you entered is incorrect': {
      zh: '您输入的登录密码不正确',
      en: 'The login password you entered is incorrect',
      ja: '入力したログインパスワードが正しくありません'
    },
    'The user center password you entered is incorrect': {
      zh: '您输入的用户中心密码不正确',
      en: 'The User Center password you entered is incorrect',
      ja: '入力したユーザーセンターのパスワードが正しくありません'
    }
  }
  return (messageMap[msg] && messageMap[msg][localeKey]) || msg
}

// 1. 创建新的axios实例，
const service = axios.create({
  // 公共接口--这里注意后面会讲
  // baseURL: process.env.NODE_ENV === 'production' ? serverUrl : '',
  // 超时时间 单位是ms，这里设置了3s的超时时间
  timeout: 120 * 1000
})
// 2.请求拦截器
let loadingInstance
service.interceptors.request.use(
  (config) => {
    // 发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等
    // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
    const token = cookie.get('kg-client-token')
    const { loading = true } = config
    config.data = JSON.stringify(config.data)
    config.headers = {
      'x-requested-with': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      token: token || ''
    }
    if (loading) {
      loadingInstance = Loading.service({
        // text: 'loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 添加响应拦截器
service.interceptors.response.use(
  (response) => {
    const code = responseCode(response.data)
    loadingInstance && loadingInstance.close()
    if (response.config.direct) {
      return Promise.resolve(response.data)
    }
    if (code === 200) {
      // 服务端定义的响应code码为0时请求成功
      return Promise.resolve(response.data.data) // 使用Promise.resolve 正常响应
    } else if ([405, 406].includes(code)) {
      // 服务端定义的响应code码为1401时为未登录
      // store.dispatch('setUserInfo', {})
      router.push('/sign/sign-in')
      return Promise.reject(translateServerMessage(response.data.msg))
    } else {
      console.log(code === 408)
      const translatedMsg = translateServerMessage(responseMessage(response.data, '接口未返回有效结果，请刷新记录确认状态，勿重复提交资金操作。'))
      if (response.config.silentError) return Promise.reject(new Error(translatedMsg))
      MessageBox.alert(translatedMsg, {
        confirmButtonText: i18n.t('my25'),
        center: true,
        customClass: 'warning-alert',
        callback: (action) => {
          if (response.data.code === 408) {
            const pathname = window.location.pathname
            if (pathname.includes('proxy')) {
              router.push({ name: 'proxyInfo' })
            } else {
              router.push({ name: 'userInfo' })
            }
          }
        }
      })
      return Promise.reject(new Error(translatedMsg))
    }
  },
  (error) => {
    console.log('error:', error)
    loadingInstance && loadingInstance.close()
    if (error.config && error.config.silentError) return Promise.reject(error)
    MessageBox.alert('System Exception', 'Tips', {
      confirmButtonText: i18n.t('my25'),
      customClass: 'warning-alert',
      callback: (action) => { }
    })
    return Promise.reject(error)
  }
)

// 4.导入文件
export default service
